export default "__VITE_ASSET__arpECwTf__"